// BB11St 07850251913  EY60LAA

import { Flex } from "@chakra-ui/react";
// import useCheckMobileScreen from "hooks/useCheckMobileScreen";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { api } from "services/api";
import { toaster } from "components/ui/toaster";
import { Header } from "components/Header";
import utils from "utils";
import InputComp from "components/InputComp";
import Layout from "components/Layout";
import ButtonComp from "components/Button";
import Modal from "components/Modal";

function AgreementsAdd() {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const action = location.state?.action;
  const itemData = location.state?.data;

  // menual
  const [policyTypes, setPolicyTypes] = useState();
  const [dealers, setDealers] = useState();
  const [titles, setTitiles] = useState([]);
  const [addressList, setAddressList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const navigate = useNavigate();
  // const ismobile = useCheckMobileScreen();

  const [address1, setAddress1] = useState(itemData?.address1 || "");
  const [address2, setAddress2] = useState(itemData?.address2 || "");
  const [address3, setAddress3] = useState(itemData?.address3 || "");
  const [company, setCompany] = useState(itemData?.company || "");
  // const [country, setCountry] = useState(itemData?.country || "");
  const [email, setEmail] = useState(itemData?.email || "");
  const [forename, setForename] = useState(itemData?.forename || "");
  const [hometel, setHometel] = useState(itemData?.hometel || "");
  const [mobile, setMobile] = useState(itemData?.mobile || "");
  // const [policyid, setPolicyid] = useState(itemData?.policyid || "");
  // const [policynumber, setPolicynumber] = useState(
  // itemData?.policynumber || ""
  // );
  const [postcode, setPostcode] = useState(itemData?.postcode || "");
  const [surname, setSurname] = useState(itemData?.surname || "");
  const [title, setTitle] = useState(itemData?.title || "");
  const [town, setTown] = useState(itemData?.town || "");
  // const [recordtype, setRecordtype] = useState(itemData?.recordtype || "");
  // const [branchid, setBranchid] = useState(itemData?.branchid || "");
  const [branchname, setBranchname] = useState(itemData?.branchname || "");
  // const [dateseconds, setDateseconds] = useState(itemData?.dateseconds || "");
  const [coverid, setCoverid] = useState(itemData?.coverid || "");
  // const [operator, setOperator] = useState(itemData?.operator || "");
  // const [state, setState] = useState(itemData?.state || "");
  const [datepolicy, setDatepolicy] = useState(itemData?.datepolicy);
  // const [invoiceid, setInvoiceid] = useState(itemData?.invoiceid || "");
  // const [nett, setNett] = useState(itemData?.nett || "");
  // const [tax, setTax] = useState(itemData?.tax || "");
  // const [gross, setGross] = useState(itemData?.gross || "");
  // const [invoicenumber, setInvoicenumber] = useState(
  // itemData?.invoicenumber || ""
  // );
  // const [vatpercent, setVatpercent] = useState(itemData?.vatpercent || "");
  const [county, setCounty] = useState(itemData?.county || "");
  // const [poladmincosttype, setPoladmincosttype] = useState(
  //   itemData?.poladmincosttype || ""
  // );
  // const [poladmincostcent, setPoladmincostcent] = useState(
  //   itemData?.poladmincostcent || ""
  // );
  // const [poladmincostamt, setPoladmincostamt] = useState(
  //   itemData?.poladmincostamt || ""
  // );
  // const [pricepaid, setPricepaid] = useState(itemData?.pricepaid || "");
  // const [deposit, setDeposit] = useState(itemData?.deposit || "");
  // const [notifyemail, setNotifyemail] = useState(itemData?.notifyemail || "");
  // const [policycommissionaccount, setPolicycommissionaccount] = useState(
  //   itemData?.policycommissionaccount || ""
  // );
  // const [policycommissiontype, setPolicycommissiontype] = useState(
  //   itemData?.policycommissiontype || ""
  // );
  // const [policycommissionamt, setPolicycommissionamt] = useState(
  //   itemData?.policycommissionamt || ""
  // );
  // const [policycommissioncent, setPolicycommissioncent] = useState(
  //   itemData?.policycommissioncent || ""
  // );
  // const [policycommissionvalue, setPolicycommissionvalue] = useState(
  //   itemData?.policycommissionvalue || ""
  // );
  // const [policycommissionpaytype, setPolicycommissionpaytype] = useState(
  //   itemData?.policycommissionpaytype || ""
  // );
  // const [vatcalculation, setVatcalculation] = useState(
  //   itemData?.vatcalculation || ""
  // );
  // const [policyrefundtype, setPolicyrefundtype] = useState(
  //   itemData?.policyrefundtype || ""
  // );
  // const [policyrefundvalue, setPolicyrefundvalue] = useState(
  //   itemData?.policyrefundvalue || ""
  // );
  // const [policyrefundduration, setPolicyrefundduration] = useState(
  //   itemData?.policyrefundduration || ""
  // );
  // const [refunddone, setRefunddone] = useState(itemData?.refunddone || "");
  // const [taxadmin, setTaxadmin] = useState(itemData?.taxadmin || "");
  // const [dateexpiry, setDateexpiry] = useState(itemData?.dateexpiry || "");
  // const [renewnotified, setRenewnotified] = useState(
  //   itemData?.renewnotified || ""
  // );
  // const [accepted, setAccepted] = useState(itemData?.accepted || "");
  // const [customersent, setCustomersent] = useState(
  //   itemData?.customersent || ""
  // );
  // const [customerstripeid, setCustomerstripeid] = useState(
  //   itemData?.customerstripeid || ""
  // );
  // const [carmake, setCarmake] = useState(itemData?.carmake || "");
  // const [carmodel, setCarmodel] = useState(itemData?.carmodel || "");
  // const [cartype, setCartype] = useState(itemData?.cartype || "");
  // const [enginecapacity, setEnginecapacity] = useState(
  //   itemData?.enginecapacity || ""
  // );
  // const [fourbyfour, setFourbyfour] = useState(itemData?.fourbyfour || "");
  // const [fueltype, setFueltype] = useState(itemData?.fueltype || "");
  // const [luxury, setLuxury] = useState(itemData?.luxury || "");
  // const [mileage, setMileage] = useState(itemData?.mileage || "");
  // const [purchaseprice, setPurchaseprice] = useState(
  //   itemData?.purchaseprice || ""
  // );
  // const [specialist, setSpecialist] = useState(itemData?.specialist || "");
  // const [transmission, setTransmission] = useState(
  //   itemData?.transmission || ""
  // );
  // const [vin, setVin] = useState(itemData?.vin || "");
  // const [vrm, setVrm] = useState(itemData?.vrm || "");
  // const [vehicleid, setVehicleid] = useState(itemData?.vehicleid || "");
  // const [extranum, setExtranum] = useState(itemData?.extranum || "");
  // const [datepurchase, setDatepurchase] = useState(
  //   itemData?.datepurchase || ""
  // );
  // const [regdate, setRegdate] = useState(itemData?.regdate || "");
  // // const [policynumber, setPolicynumber] = useState(itemData?.policynumber || '');
  // const [carcolour, setCarcolour] = useState(itemData?.carcolour || "");
  // const [policyidvehicle, setPolicyidvehicle] = useState(
  //   itemData?.policyidvehicle || ""
  // );
  // const [guaranteeid, setGuaranteeid] = useState(itemData?.guaranteeid || "");
  // const [startdate, setStartdate] = useState(
  //   utils.dateToDateInput(itemData?.startdate)
  // );
  const [covertype, setCovertype] = useState(itemData?.covertype || "");
  // const [vehiclecategory, setVehiclecategory] = useState(
  //   itemData?.vehiclecategory || ""
  // );
  // const [durationid, setDurationid] = useState(itemData?.durationid || "");
  // const [mileageband, setMileageband] = useState(itemData?.mileageband || "");
  // const [dpfs, setDpfs] = useState(itemData?.dpfs || "");
  // const [higherlabourrate, setHigherlabourrate] = useState(
  //   itemData?.higherlabourrate || ""
  // );
  // const [weartear, setWeartear] = useState(itemData?.weartear || "");
  // const [egrvalves, setEgrvalves] = useState(itemData?.egrvalves || "");
  // const [catalyticconverter, setCatalyticconverter] = useState(
  //   itemData?.catalyticconverter || ""
  // );
  // const [retailprice, setRetailprice] = useState(itemData?.retailprice || "");
  // // const [policynumber, setPolicynumber] = useState(itemData?.policynumber || '');
  // const [claimlimitamount, setClaimlimitamount] = useState(
  //   itemData?.claimlimitamount || ""
  // );
  // const [claimlimitid, setClaimlimitid] = useState(
  //   itemData?.claimlimitid || ""
  // );
  // // const [coverid, setCoverid] = useState(itemData?.coverid || '');
  // const [startdateseconds, setStartdateseconds] = useState(
  //   itemData?.startdateseconds || ""
  // );
  // const [policyidguarantee, setPolicyidguarantee] = useState(
  //   itemData?.policyidguarantee || ""
  // );
  // // const [durationid, setDurationid] = useState(itemData?.durationid || '');
  // const [durationtype, setDurationtype] = useState(
  //   itemData?.durationtype || ""
  // );
  // const [active, setActive] = useState(itemData?.active || "");
  // const [hide, setHide] = useState(itemData?.hide || "");
  // const [durationvalue, setDurationvalue] = useState(
  //   itemData?.durationvalue || ""
  // );

  const onNext = () => {
    let errMsg = false;

    const navData = {
      ...itemData,
      dealerid: utils.getDealerid(dealers),
      coverid: coverid, // utils.getCoverid(policyTypes),
      company,
      forename,
      surname,
      postcode,
      address1,
      address2,
      address3,
      town: town,
      county: county,
      // country: county,
      title,
      branchid: utils.getDealerid(dealers),
      branchname,
      email,
      hometel,
      mobile,
      covertype,
      dateseconds: datepolicy ? utils.yyyymmddToDbSec(datepolicy) : 0,
      datepolicy: datepolicy,
    };

    if (errMsg === false && !navData.datepolicy) {
      errMsg = "datepolicy";
    }

    if (errMsg === false && !navData.branchname) {
      errMsg = "branchname";
    }

    if (errMsg === false && !navData.coverid) {
      errMsg = "type";
    }

    // if (errMsg === false && title) {
    //   errMsg = "title";
    // }

    // if (errMsg === false && !company) {
    //   errMsg = "company";
    // }

    if (errMsg === false && !navData.forename) {
      errMsg = "forename";
    }

    if (errMsg === false && !navData.surname) {
      errMsg = "surname";
    }

    if (errMsg === false && !navData.postcode) {
      errMsg = "postcode";
    }

    if (errMsg === false && !navData.address1) {
      errMsg = "address";
    }

    if (errMsg === false && !utils.validateEmail(navData.email)) {
      errMsg = "Email";
    }

    if (
      errMsg === false &&
      navData.hometel &&
      !utils.validateLandlineNum(navData.hometel)
    ) {
      errMsg = "hometel";
    }

    if (errMsg === false && !utils.validateMobileNum(navData.mobile)) {
      errMsg = "mobile";
    }

    if (errMsg) {
      toaster.create({
        title: "enter valid " + errMsg,
        type: "error",
      });
      return;
    }

    console.log("onNext", itemData);

    console.log("action  1", action);

    // const newData = {};
    navigate("/vehicledetails", {
      state: {
        action: "agreement-edit-2",
        data: navData,
      },
    });
  };

  const onBack = () => {
    navigate("/agreements");
  };

  const onDealersChange = (data) => {
    console.log("onDealersChange", data);

    setDealers(data?.list ? [...data.list] : []);

    if (data?.action === "useState") {
      setBranchname(data?.item?.label || itemData?.branchname || "");
    } else {
      setBranchname(data?.item?.label || "");
    }

    if (data?.item?.data?.dealerid || data?.item?.data?.dealerid === 0) {
      getPolicyTypes({
        dealerid: data?.item?.data?.dealerid,
        action: data?.action,
      });
    } else {
      getPolicyTypes();
    }
  };

  const onChangePolicyTypes = (data) => {
    setPolicyTypes(data?.list ? [...data.list] : []);
    setCovertype(data?.item?.label || "");
    setCoverid(data?.item?.data?.coverid);
  };

  const getPolicyTypes = (data) => {
    if (!data) {
      onChangePolicyTypes({
        list: [],
      });
      return;
    }
    setIsLoading(true);
    api
      .getPolicyTypes({
        dealerid: data?.dealerid,
      })
      .then((res) => {
        setIsLoading(false);

        console.log("getPolicyTypes =", res);
        if (res?.status === 200) {
          if (res?.data && res?.data[0]) {
            const arr = res.data.map((a, index) => ({
              key: `policytype-${index}`,
              value: `${a.covername}-${index}`,
              label: a.covername,
              data: a,
            }));

            if (data?.action === "useState" && itemData?.coverid) {
              let inx;
              let item;
              let arr2;

              arr2 = arr?.map((a, index) => {
                if (a.data.coverid === itemData.coverid) {
                  a.selected = true;
                  inx = index;
                  item = a;
                } else {
                  a.selected = false;
                }
                return a;
              });

              onChangePolicyTypes({
                index: inx,
                item: item,
                list: arr2,
              });
            } else {
              onChangePolicyTypes({
                // index: inx,
                // item: item,
                list: arr,
              });
              // arr[0].selected = true;
              // setPolicyTypes(arr);
              // getList({ dealerid: arr[0].data.dealerid });
            }
          } else {
            onChangePolicyTypes({
              list: [],
            });
          }
        } else {
          toaster.create({
            title: res?.message,
            type: "error",
          });
        }
      });
  };

  const onChangeTitles = (data) => {
    console.log("vkp", data?.item?.data);

    setTitiles(data?.list ? [...data.list] : []);
    setTitle(data?.item?.data?.value || "");
  };

  const onClickFindAddress = () => {
    setIsLoading(true);
    api.getAddress({ postcode: postcode }).then((res) => {
      console.log("onClickFindAddress", res);
      setIsLoading(false);
      if (res.status === 200) {
        if (res?.data && res.data[0]) {
          setAddressList(res.data);
          setIsModalOpen(true);
        } else {
          toaster.create({
            title:
              res?.data?.message ||
              res?.message ||
              res?.response?.data?.message ||
              "no address found",
            type: "error",
          });
        }
      } else {
        toaster.create({
          title: res?.message || "error find address",
          type: "error",
        });
      }
    });
  };

  const onSelectAddress = (v) => {
    console.log("onSelectAddress v", v);
    setIsModalOpen(false);

    setAddress1(v?.item?.address1);
    setAddress2(v?.item?.address2);
    setAddress3(v?.item?.address3);

    // let town2 = "";
    // let county2 = "";

    // if (address3?.split) {
    //   const aa = address3.split(",");

    //   if (aa && aa[0]) {
    //     town2 = aa[0];
    //   }

    //   if (aa && aa[1]) {
    //     county2 = aa[1];
    //   }
    // }

    setTown(v?.item?.town || "");
    setCounty(v?.item?.county || "");

    return;

    // const address1 = v?.item?.address1?.trim?.() || "";
    // const address2 = v?.item?.address2?.trim?.() || "";
    // const address3 = v?.item?.address3?.trim?.() || "";

    // // Combine all parts into one line, with proper commas
    // let fullAddress = [address1, address2, address3].filter(Boolean).join(", ");

    // // Split into components by comma
    // let addrs = fullAddress
    //   .split(",")
    //   .map((s) => s.trim())
    //   .filter(Boolean);

    // let addressline1 = "";
    // let addressline2 = "";
    // let addressline3 = "";

    // if (addrs.length >= 1) {
    //   addressline1 = addrs[0];
    // }

    // if (addrs.length >= 3) {
    //   addressline3 = addrs[addrs.length - 1];
    //   addressline2 = addrs.slice(1, addrs.length - 1).join(", ");
    // } else if (addrs.length === 2) {
    //   addressline3 = addrs[1];
    // }

    // console.log("Split Address Lines:", {
    //   addressline1,
    //   addressline2,
    //   addressline3,
    // });

    // // Update state
    // setAddress1(addressline1);
    // setAddress2(addressline2);
    // setAddress3(addressline3);

    // setIsModalOpen(false);
  };

  // const initTitles = () => {
  //   if (itemData?.title && constant?.personTitles) {
  //     let indx;
  //     let item;
  //     let list2 = constant.personTitles.map((a, index) => {
  //       if (a?.label === itemData?.title) {
  //         a.selected = true;
  //         indx = index;
  //         item = a;
  //       } else {
  //         a.selected = false;
  //       }
  //       return a;
  //     });
  //     onChangeTitles({
  //       index: indx,
  //       item: item,
  //       list: list2,
  //       action: "useState",
  //     });
  //   }
  // };

  useEffect(() => {
    console.log("useEffect", itemData);

    const cb = async () => {
      // initTitles();
      utils.getPreTitleDD({
        action: "useState",
        defaultVal: itemData?.title,
        onChangeTitles,
      });

      setDatepolicy(utils.dateToDateInput(itemData?.datepolicy));

      await utils.getDealers({
        setIsLoading,
        action: "useState",
        onDealersChange,
        allOption: false,
        defaultVal: itemData?.branchid,
      });
    };
    cb();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header
        label={`Agreement${
          action === "agreement-edit"
            ? `${itemData?.policynumber ? " - " + itemData?.policynumber : ""}`
            : ""
        }`}
        isLoading={isLoading}
      />
      <Modal
        isopen={isModalOpen}
        type={"list"}
        items={addressList}
        onSelect={onSelectAddress}
        title={"Found Addresses"}
        setIsOpen={setIsModalOpen}
      />
      <Layout gap={"1rem"}>
        {/* <SimpleGrid
          columns={ismobile ? 1 : 1}
          // maxWidth={"25rem"}
          columnGap="1rem"
          rowGap="1rem"
        > */}

        <InputComp
          label={"Date Entered"}
          value={utils.dateToDateInput(datepolicy)}
          type="date"
          onChange={setDatepolicy}
          required={true}
          disabled={action === "agreement-edit"}
        />

        <InputComp
          type="dropdown"
          label={"Branch"}
          items={dealers}
          onChange={onDealersChange}
          placeholder={"Select Branch"}
          required={true}
        />

        <InputComp
          type="dropdown"
          label={"Type"}
          placeholder={"Select Type"}
          items={policyTypes}
          onChange={onChangePolicyTypes}
          required={true}
        />

        <InputComp
          type="dropdown"
          label={"Title"}
          placeholder={"Select Title"}
          items={titles}
          onChange={onChangeTitles}
          required={false}
        />

        <InputComp
          label={"Company"}
          value={company}
          onChange={setCompany}
          required={false}
        />

        <InputComp
          label={"Firstname"}
          value={forename}
          onChange={setForename}
          required={true}
        />

        <InputComp
          label={"Surname"}
          value={surname}
          onChange={setSurname}
          required={true}
        />

        {/* <Flex h={"1rem"} /> */}
        {/* </SimpleGrid> */}
        {/* <Flex
          // pt={"4rem"}
          // pb={"1rem"}
          // columns={1}
          // columnGap="1rem"
          // rowGap="1rem"
          py={"1rem"}
          gapY={"1rem"}
          // wrap={"wrap"}
          overflow={"hidden"}
          // maxWidth={"25rem"}
        > */}

        {/* <Flex h={"1rem"} /> */}

        <InputComp
          label={"Postcode"}
          value={postcode}
          onChange={setPostcode}
          required={true}
        />

        <Flex alignSelf={"flex-end"}>
          <ButtonComp
            // w={"7rem"}
            // bg="text"
            // textStyle={fs}
            onClick={onClickFindAddress}
            label={"Find Address"}
            keyname="findadd"
            bg="button.solid"
            color="white"
            disabled={isLoading}
          />
        </Flex>
        {/* </Flex> */}
        {/* </SimpleGrid> */}

        {/* <SimpleGrid
          columns={ismobile ? 1 : 1}
          columnGap="1rem"
          rowGap="1rem"
          py={"1rem"}
          // maxWidth={"25rem"}
        > */}
        <InputComp
          label={"Home Address"}
          value={address1}
          onChange={setAddress1}
          required={true}
        />

        <InputComp label={" "} value={address2} onChange={setAddress2} />

        <InputComp label={" "} value={address3} onChange={setAddress3} />
        {/* </SimpleGrid> */}

        {/* <SimpleGrid
          columns={ismobile ? 1 : 1}
          // maxWidth={"25rem"}
          columnGap="1rem"
          rowGap="1rem"
        > */}

        <InputComp
          label={"Town"}
          value={town}
          onChange={setTown}
          // required={true}
        />

        <InputComp
          label={"County"}
          value={county}
          onChange={setCounty}
          // required={true}
        />

        <InputComp
          label={"Email"}
          value={email}
          onChange={setEmail}
          required={true}
        />

        <InputComp
          type="number"
          label={"Home Telephone"}
          value={hometel}
          onChange={setHometel}
          required={false}
        />

        <InputComp
          type="number"
          label={"Mobile"}
          value={mobile}
          onChange={setMobile}
          required={true}
        />

        {/* <Flex maxWidth={"15rem"}>
            <Field.Root orientation="horizontal" gap={4}>
              <Field.Label textStyle={fs}>
                Date Entered
                <Field.Label color={"red"}>*</Field.Label>
              </Field.Label>
              <Input
                value={utils.dateToDateInput(datepolicy)}
                type="date"
                flex="1"
                textStyle={fs}
                onChange={(e) => setDatepolicy(e.currentTarget.value)}
              />
            </Field.Root>
          </Flex> */}

        {/* <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>
              Branch <Field.Label color={"red"}>*</Field.Label>
            </Field.Label>
            <DropDown
              w={"100%"}
              items={dealers}
              onChange={onDealersChange}
              placeholder={"Select Branch"}
            />
          </Field.Root> */}

        {/* <Flex h={"1rem"} /> */}

        {/* <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>
              Type <Field.Label color={"red"}>*</Field.Label>
            </Field.Label>
            <DropDown
              placeholder={"Select Type"}
              w={"100%"}
              items={policyTypes}
              onChange={onChangePolicyTypes}
            />
          </Field.Root> */}

        {/* <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Title</Field.Label>
            <DropDown
              placeholder={"Select Title"}
              w={"100%"}
              items={titles}
              onChange={onChangeTitles}
            />
          </Field.Root> */}

        {/* <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Company</Field.Label>
            <Input
              type="text"
              value={company}
              onChange={(e) => setCompany(e.target.value)}
              textStyle={"md"}
            />
          </Field.Root> */}
        {/* <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>
              Firstname <Field.Label color={"red"}>*</Field.Label>
            </Field.Label>
            <Input
              type="text"
              value={forename}
              onChange={(e) => setForename(e.target.value)}
              textStyle={"md"}
            />
          </Field.Root> */}

        {/* <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>
              Surname <Field.Label color={"red"}>*</Field.Label>
            </Field.Label>
            <Input
              type="text"
              value={surname}
              onChange={(e) => setSurname(e.target.value)}
              textStyle={"md"}
            />
          </Field.Root> */}
        {/* </SimpleGrid> */}

        {/* <Flex h={"1rem"} /> */}

        {/* <SimpleGrid
            // pt={"4rem"}
            // pb={"1rem"}
            columns={ismobile ? 1 : 2}
            columnGap="1rem"
            rowGap="1rem"
          >
            <Field.Root orientation="horizontal" gap={4}>
              <Field.Label textStyle={fs}>
                Postcode <Field.Label color={"red"}>*</Field.Label>
              </Field.Label>
              <Input
                type="text"
                value={postcode}
                onChange={(e) => setPostcode(e.target.value)}
                textStyle={"md"}
              />
            </Field.Root>
            <Button
              w={"12rem"}
              bg="primary"
              textStyle={fs}
              onClick={onClickFindAddress}
            >
              Find Address
            </Button>
          </SimpleGrid> */}

        {/* <SimpleGrid columns={ismobile ? 1 : 1} columnGap="2rem" rowGap="2"> */}
        {/* <Field.Root mt={"0.5rem"} orientation={"horizontal"} gap={4}>
            <Field.Label textStyle={fs}>
              Home Address <Field.Label color={"red"}>*</Field.Label>
            </Field.Label>
            <Input
              value={`${address1}`}
              onChange={(e) => setAddress1(e.currentTarget.value)}
              type="text"
              flex="1"
              textStyle={fs}
            />
          </Field.Root> */}

        {/* <Field.Root columns={1} orientation="horizontal" gap={4}> 
          <Field.Label textStyle={fs} />
          <Input
            value={`${address1}`}
            onChange={(e) => setAddress1(e.currentTarget.value)}
            type="text"
            flex="1"
            textStyle={fs}
          />
        </Field.Root> */}

        {/* <Field.Root columns={1} orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs} />
            <Input
              value={`${address2}`}
              onChange={(e) => setAddress2(e.currentTarget.value)}
              type="text"
              flex="1"
              textStyle={fs}
            />
          </Field.Root>

          <Field.Root columns={1} orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs} />

            <Input
              value={`${address3}`}
              onChange={(e) => setAddress3(e.currentTarget.value)}
              type="text"
              flex="1"
              textStyle={fs}
            />
          </Field.Root> */}

        {/* <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>
              Email <Field.Label color={"red"}>*</Field.Label>
            </Field.Label>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              textStyle={"md"}
            />
          </Field.Root> */}
        {/* <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Home Telephone</Field.Label>
            <Input
              type="tel"
              value={hometel}
              onChange={(e) => setHometel(e.target.value)}
              textStyle={"md"}
            />
          </Field.Root> */}

        {/* <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>
              Mobile <Field.Label color={"red"}>*</Field.Label>
            </Field.Label>
            <Input
              type="tel"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              textStyle={"md"}
            />
          </Field.Root> */}
        {/* </SimpleGrid> */}
      </Layout>
      {/* <SimpleGrid mt={"1rem"} columns={"1rem"} columnGap="1rem" rowGap="1rem">
      </SimpleGrid> */}
      <Flex pt={"1rem"} gap={"1rem"} alignItems={"center"} justify={"end"}>
        <ButtonComp label={"Close"} onClick={onBack} keyname="close" />
        <ButtonComp label={"Next"} onClick={onNext} keyname="next" disabled={isLoading} />
        {/* <Button
            onClick={onNext}
            // colorPalette="primary"
            bg="text"
            w={width1}
          >
            Next
          </Button> */}
      </Flex>
    </Flex>
  );
}

export default AgreementsAdd;
